<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i> Export</b-button
          >
          <b-button variant="primary mr-1" @click="reprosesBulkconfirm()"
            ><i class="fa fa-refresh"></i> Reprocess OS</b-button
          >
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Loan No.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.loan_id"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Customer ID</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.customerID"
              placeholder=""
            ></b-form-input>
            <b-input-group-append>
              <label>Fullname</label>
            </b-input-group-append>
            <b-form-input v-model="tblData.debtorFullName"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <div>
            <b-input-group>
              <b-input-group-prepend>
              <label>Project</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>
        
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                  <i class="fa fa-eraser"></i>Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
        :busy="isBusy"
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(installmentEndDate)="data">{{
          data.item.installmentEndDate | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(installmentStartDate)="data">{{
          data.item.installmentStartDate | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(genderCode)="data">
          <span v-if="data.item.genderCode == 'L'">Male</span>
          <span v-else-if="data.item.genderCode == 'P'">Female</span>
        </template>
        <template v-slot:cell(action)="data">
          <a
            href="javascript:void(0)"
            @click.stop="reprosesconfirm(data.item)"
            v-b-tooltip.hover
            title="Reprocess Calc. Outstanding"
          >
            <i class="fa fa-refresh"></i>
          </a>
          |
          <a
            href="javascript:void(0)"
            @click.stop="viewdetail(data.item)"
            v-b-tooltip.hover
            title="Clik to view detail"
          >
            <i class="fa fa-eye"></i>
          </a>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showReprosesConfirm"
      title="Reproses Outstanding Record?"
      :centered="true"
      @ok="reproses"
    >
      <p class="mb-1">1 record is about to be permanently reprocess</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal
      v-model="showReprosesBulkConfirm"
      title="Reproses Outstanding Record?"
      :centered="true"
      @ok="reprosesbulk"
    >
      <p class="mb-1">All record is about to be permanently reprocess</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<style scoped>
/* Busy table styling */
table.b-table[aria-busy="true"] {
  opacity: 0.6;
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import loan from "../../apis/loan";
toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      showReprosesConfirm: false,
      showReprosesBulkConfirm: false,
      projectsFilt:[{
        value:'',text:'-- ALL --'
      }],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "partnerLoanApplicationNumber",
        sortDesc: false,
        tablename: "loan",
        loan_id: "",
        // tgl1: moment().startOf('M').format('YYYY-MM-DD'),
        tgl1: moment().format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        customerID: "",
        debtorFullName: "",
        pjxkey:''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "partnerLoanApplicationNumber",
          label: "Loan App. Number",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "customerID",
          label: "Customer ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "debtorFullName",
          label: "Customer Fullname",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "genderCode",
          label: "Gender",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "installmentStartDate",
          label: "Installment Start Date",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "installmentEndDate",
          label: "Installment End Date",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "-",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ];
      return fields;
    },
  },
  async created() {
    const filter = this.$store.state.filter;
    for (var key in filter[this.$route.name]) {
      this.tblData[key] = filter[this.$route.name][key];
    }


    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
    
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    saveFilter() {
      let filtered = false;
      const filterObj={};
      for (const key in this.tblData) {
        filterObj[key]=this.tblData[key];
        filtered=true;
      }
      if (filtered === true) {
          const filter = this.$store.state.filter;
          filter[this.$route.name]=filterObj;
          this.$store.commit("filter", filter);
      }
    }, 
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter[this.$route.name]) {
          this.tblData[key] = filter[this.$route.name][key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter[this.$route.name];
          this.$store.commit("filter", filter);
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await loan.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await loan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.isBusy = false;
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    reprosesconfirm(data) {
      this.showReprosesConfirm = true;
      this.rowClicked(data);
    },
    async reproses() {
      try {
        this.isLoading = true;
        let data = this.model;
        await loan.prosesOutstandingLoan(data);
        this.isLoading = false;
        toastr.success("The record successfully reprocess", "SUCCESS", 10000);
      } catch (error) {
        this.isLoading = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    reprosesBulkconfirm() {
      this.showReprosesBulkConfirm = true;
    },
    async reprosesbulk() {
      try {
        this.isLoading = true;
        await loan.prosesOutstandingLoanBulk(this.tblData);
        this.isLoading = false;
        toastr.success("The record successfully reprocess", "SUCCESS", 10000);
      } catch (error) {
        this.isLoading = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async viewdetail(data) {
      this.saveFilter();
      router.push({
        name: "transaction.loanform",
        params: { loan_id: data.loan_id },
      });
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "partnerLoanApplicationNumber",
        sortDesc: false,
        tablename: "loan",
        loan_id: "",
        tgl1: "",
        tgl2: "",
        customerID: "",
        debtorFullName: "",
      };
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>